export enum AddressType {
  ADDRESS = 'address',
  OVERSEA_ADDRESS = 'overseaAddress',
  STORE_ADDRESS = 'storeAddress',
}
